import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Chip } from '@frontend/design-system';
import { ServiceHistory } from '../../types';

interface ServiceDatesRendererProps {
  serviceDates: ServiceHistory[];
}

export const ServiceDatesRenderer = ({ serviceDates }: ServiceDatesRendererProps) => {
  const getChipKey = (serviceDateObj: ServiceHistory): string => {
    const procedureCode = serviceDateObj?.procedure_code || '';
    const serviceDate = serviceDateObj?.service_date || '';
    return !!procedureCode && !!serviceDate ? procedureCode + serviceDate : serviceDate;
  };

  const getChipValue = (serviceDateObj: ServiceHistory): string => {
    const chipValue: string[] = [];

    if (serviceDateObj?.procedure_code) {
      chipValue.push(serviceDateObj.procedure_code);
    }

    if (serviceDateObj?.service_date) {
      chipValue.push(serviceDateObj.service_date);
    }

    return chipValue.join(': ');
  };

  return (
    <div css={serviceDatesCellContainer}>
      {serviceDates.map((serviceDateObj) => (
        <Chip css={{ minWidth: '145px' }} variant='primary' key={getChipKey(serviceDateObj)}>
          {getChipValue(serviceDateObj)}
        </Chip>
      ))}
    </div>
  );
};

const serviceDatesCellContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
});
